import { assets } from "@/lib/assets"

const items = [
  {
    no: "01",
    title: "SCENT",
    subtitle: "香氛噴霧",
    desc: "隨身收藏那一刻的微光。",
    image: assets.bottleSilk,
    tall: false,
  },
  {
    no: "02",
    title: "GIFT SET",
    subtitle: "限定包裝 · 精緻禮盒",
    desc: "以音樂為靈感的視覺設計，送給重要的人，也送給曾經的自己。",
    image: assets.productSet,
    imageMobile: assets.productSetMobile,
    tall: true,
  },
]

function Collection() {
  return (
    <section id="collection" data-nav="dark" className="bg-[#f4f0e8] px-8 py-20 md:px-10 md:py-28">
      <div className="mx-auto max-w-5xl">
        <div className="mb-12">
          <h2 className="font-display text-[34px] tracking-[0.18em] text-slate-700 md:text-[42px]">
            THE COLLECTION
          </h2>
          <p className="mt-3 text-[13px] tracking-[0.16em] text-slate-500">
            一段演出，一款氣味，一份記憶
          </p>
        </div>

        <div className="space-y-10">
          {items.map((item) => (
            <article key={item.no} className="grid items-center gap-6 md:grid-cols-[1.15fr_0.85fr] md:gap-10">
              <div className={`overflow-hidden bg-[#d7e0e8] ${item.tall ? "aspect-[4/5] md:aspect-[16/10]" : "aspect-[16/11]"}`}>
                {item.imageMobile ? (
                  <>
                    <img
                      src={item.imageMobile}
                      alt={item.subtitle}
                      className="h-full w-full object-cover md:hidden"
                    />
                    <img
                      src={item.image}
                      alt={item.subtitle}
                      className="hidden h-full w-full object-cover md:block"
                    />
                  </>
                ) : (
                  <img
                    src={item.image}
                    alt={item.subtitle}
                    className="h-full w-full object-cover"
                  />
                )}
              </div>
              <div className="md:pl-4">
                <p className="font-display text-sm tracking-[0.28em] text-slate-400">{item.no}</p>
                <h3 className="mt-3 font-display text-[22px] tracking-[0.2em] text-slate-700">
                  {item.title}
                </h3>
                <p className="mt-1 text-[13px] tracking-[0.18em] text-slate-500">{item.subtitle}</p>
                <p className="mt-4 max-w-xs text-[13px] leading-7 text-slate-500">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Collection
